import React from 'react';
import {connect} from 'react-redux';
import util from 'Utils/commonUtil';

// Components
import Header from 'Components/common/Header';
import SearchInput from 'Components/common/SearchInput';
import ScrollWrapper from 'Components/common/ScrollWrapper';
import TaskManagementItem from 'Components/host/taskManagement/TaskManagementItem';
import BackTop from 'Components/common/BackTop';

// Actions
import {
    updateF1OrderSearchList,
    updateF1OrderList,
    updateF1OrderTabActive,
    setF1OrderSource,
    updateF1OrderListPageNum,
    setF1OrderOnGoPackageSource,
    updateF1OrderOnGoPackageListPageNum,
    updateF1OnGoPackageSort,
} from 'Actions/host';
import {getTaskList, updateTaskListSearchfields} from 'Actions/taskManagement';
import {T} from 'Actions/translate';

class TaskManagementList extends React.Component {
    pager = {
        page: 0,
        length: 10,
        total: 0,
        pageTotal: 9999999999999999999999999,
    };
    packagePager = {
        page: 0,
        length: 10,
        total: 0,
        pageTotal: 9999999999999999999999999,
    };

    state = {
        searchValue: '',
        tabList: [
            {
                index: 0,
                text: T('user_center_task_management_tobe_completed'),
                tabFlag: 1,
            },
            {
                index: 1,
                text: T('user_center_task_management_in_follow_up'),
                tabFlag: 2,
            },
            {
                index: 2,
                text: T('user_center_task_management_all_completed'),
                tabFlag: 3,
            },
        ],
        tabActive: 0,
        listLoaded: true,
    };

    componentWillMount() {
        this.getList();
        this.props.updateF1OrderSearchList([]);
    }

    handleChangeTab(item) {
        this.props.updateF1OrderTabActive({$set: item.index});
        this.setState({tabActive: item.index, listLoaded: false}, () => {
            const {tabList, tabActive} = this.state;

            this.props.updateF1OrderList([]);
            this.pager.page = 0;
            this.pager.total = 0;
            this.pager.pageTotal = 9999999999999999999999999;
            this.getList();
        });
    }

    getList = () => {
        const {tabList} = this.state;
        const {tabActive} = this.props;

        this.props.setF1OrderSource({$set: false});
        if (this.pager.page >= this.pager.pageTotal) return;

        this.setState({listLoaded: false});

        this.props
            .getTaskList({
                pageNum: this.pager.page + 1,
                pageSize: this.pager.length,
                tabFlag: tabList[tabActive].tabFlag,
                queryKey: this.props.queryKey ? this.props.queryKey.trim() : '',
            })
            .then((res) => {
                this.pager.page = res.pageNum;
                this.pager.total = res.total;
                this.pager.pageTotal = res.pageTotal;
                this.setState({listLoaded: true});
            });
    };

    goToSearchPage = () => this.props.history.push('/F1OrderSearchList');

    goToCustomerAssignment = (item) => {
        const {tabList} = this.state;
        const {tabActive} = this.props;
        this.props.history.push(`/host/customerForTaskAssignment/`, {
            id: item.id,
            taskName: item.taskName,
            taskNo: item.taskNo,
            tabFlag: tabList[tabActive].tabFlag,
        });
    };

    goBack = () => {
        this.props.updateTaskListSearchfields({
            queryKey: {$set: ''},
        });
        this.props.history.goBack();
    };

    search = () => {
        this.props.updateF1OrderList([]);
        this.props.updateF1OrderListPageNum({$set: 0});
        this.pager.page = 0;
        this.pager.total = 0;
        this.pager.pageTotal = 9999999999999999999999999;
        this.getList();
    };

    onChange = (title, value) => {
        this.props.updateTaskListSearchfields({
            [title]: {$set: value},
        });
    };

    render() {
        const {tabList, listLoaded} = this.state;
        const {tabActive, taskList} = this.props;

        return (
            <div className="task-management-list-container">
                <Header
                    hasUserCenter={true}
                    hasArrowBackIos={true}
                    backEvent={this.goBack}>
                    <div className="task-management-list-header">
                        <div className="task-management-list-header-title">
                            <h3 className="header-title">
                                {T('user_center_task_management')}
                            </h3>
                        </div>

                        <SearchInput
                            title="queryKey"
                            value={this.props.queryKey}
                            placeholder={T(
                                'task_details_task_search_placeholder',
                            )}
                            search={this.search}
                            onChange={this.onChange}></SearchInput>
                    </div>
                    <div className="tab-header">
                        {tabList.map((item, index) => {
                            return (
                                <div id={'taskmanagementTab' + item.index}>
                                    <a
                                        key={item.index}
                                        id={'taskTab' + item.index}
                                        className={util.getClassName({
                                            'tab-item': true,
                                            active: index === tabActive,
                                        })}
                                        onClick={() => {
                                            this.handleChangeTab(item);
                                        }}>
                                        {item.text}
                                    </a>
                                </div>
                            );
                        })}
                    </div>
                </Header>
                <ScrollWrapper
                    listLoaded={listLoaded}
                    showAbyss={this.pager.page >= this.pager.pageTotal}
                    showLoadingMore={!listLoaded}
                    getMoreData={this.getList}>
                    <ul className="task-management-list">
                        {taskList &&
                            taskList.map((item, index) => (
                                <li
                                    key={index}
                                    className="task-management-item">
                                    <TaskManagementItem
                                        item={item}
                                        index={index + 1}
                                        goToCustomerAssignment={() =>
                                            this.goToCustomerAssignment(item)
                                        }
                                        tabFlag={tabList[tabActive].tabFlag}
                                        taskList={taskList}
                                    />
                                </li>
                            ))}
                    </ul>
                    <BackTop />
                </ScrollWrapper>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {host, taskManagement} = state;
    return {
        F1OrderList: host.F1OrderList,
        F1PackageOnTheGoList: host.F1PackageOnTheGoList,
        tabActive: host.tabActive,
        fromF1OrderDetails: host.fromF1OrderDetails,
        currentF1OrderPageNum: host.currentF1OrderPageNum,
        fromF1OrderOnGoPackageDetails: host.fromF1OrderOnGoPackageDetails,
        currentF1OrderOnGoPackagePageNum: host.currentF1OrderOnGoPackagePageNum,
        f1OngoPackageIsAsc: host.f1OngoPackageIsAsc,

        taskList: taskManagement.taskList,
        queryKey: taskManagement.taskListSearchfields.queryKey,
    };
};

const mapDispatchToProps = {
    updateF1OrderSearchList,
    updateF1OrderList,
    updateF1OrderTabActive,
    setF1OrderSource,
    updateF1OrderListPageNum,
    setF1OrderOnGoPackageSource,
    updateF1OrderOnGoPackageListPageNum,
    updateF1OnGoPackageSort,

    getTaskList,
    updateTaskListSearchfields,
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskManagementList);
